import React from "react";
import { useSearchParams } from "react-router-dom";

export default function ProposalThankYouPage() {
  const [params] = useSearchParams();
  if (params.get("lang") === "es") {
    return (
      <div
        style={{
          maxWidth: 640,
          margin: "80px auto",
          padding: "0 20px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
        <h1 style={{ marginBottom: 16, fontSize: 32, fontWeight: 700 }}>
          ¡Propuesta aceptada!
        </h1>

        <p style={{ fontSize: 18, lineHeight: 1.6, marginBottom: 24, color: "#333" }}>
          Felicitaciones. Está un paso más cerca de proteger lo que más importa.
        </p>

        <div style={{
          backgroundColor: "#f8f9fa",
          padding: "24px",
          borderRadius: "8px",
          marginBottom: 32,
          border: "1px solid #e9ecef"
        }}>
          <h2 style={{ fontSize: 20, marginBottom: 12, fontWeight: 600 }}>
            Siguiente paso: hagámoslo oficial
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, marginBottom: 16, color: "#555" }}>
            Para comenzar la instalación y poner su sistema en marcha,
            necesitamos crear su cuenta segura en nuestro sistema.
          </p>
          <p style={{ fontSize: 14, color: "#666", marginBottom: 0 }}>
            Esto toma solo 2 o 3 minutos y confirma su precio.
          </p>
        </div>

        <a
          href="https://adtnow.com/adt-account-creation/"
          style={{
            display: "inline-block",
            padding: "16px 36px",
            backgroundColor: "#2563eb",
            color: "#ffffff",
            textDecoration: "none",
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 16,
            boxShadow: "0 4px 6px rgba(37, 99, 235, 0.3)",
            transition: "all 0.2s",
          }}
        >
          Cree su cuenta ahora →
        </a>

        <p style={{ marginTop: 32, fontSize: 14, color: "#666" }}>
          Un miembro de nuestro equipo le dará seguimiento pronto para programar su instalación.
          <br />
          ¿Preguntas? Responda al correo que recibió.
        </p>

        <p style={{ marginTop: 24, fontSize: 12, color: "#999" }}>
          Enlace seguro proporcionado por ALARMS AMERICA. ADT AUTHORIZED DEALER
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: 640,
        margin: "80px auto",
        padding: "0 20px",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
      <h1 style={{ marginBottom: 16, fontSize: 32, fontWeight: 700 }}>
        Proposal Accepted!
      </h1>

      <p style={{ fontSize: 18, lineHeight: 1.6, marginBottom: 24, color: "#333" }}>
        Congratulations! You're one step closer to protecting what matters most.
      </p>

      <div style={{ 
        backgroundColor: "#f8f9fa", 
        padding: "24px", 
        borderRadius: "8px",
        marginBottom: 32,
        border: "1px solid #e9ecef"
      }}>
        <h2 style={{ fontSize: 20, marginBottom: 12, fontWeight: 600 }}>
          🚀 Next Step: Let's Make It Official
        </h2>
        <p style={{ fontSize: 16, lineHeight: 1.6, marginBottom: 16, color: "#555" }}>
          To start your installation process and get your system up and running,
          we need to create your secure account in our system.
        </p>
        <p style={{ fontSize: 14, color: "#666", marginBottom: 0 }}>
          This takes just 2-3 minutes and locks in your pricing.
        </p>
      </div>

      <a
        href="https://adtnow.com/adt-account-creation/"
        style={{
          display: "inline-block",
          padding: "16px 36px",
          backgroundColor: "#2563eb",
          color: "#ffffff",
          textDecoration: "none",
          borderRadius: 8,
          fontWeight: 600,
          fontSize: 16,
          boxShadow: "0 4px 6px rgba(37, 99, 235, 0.3)",
          transition: "all 0.2s",
        }}
      >
        Create Your Account Now →
      </a>

      <p style={{ marginTop: 32, fontSize: 14, color: "#666" }}>
        A member of our team will follow up shortly to schedule your installation.
        <br />
        Questions? Reply to the email you received.
      </p>

      <p style={{ marginTop: 24, fontSize: 12, color: "#999" }}>
        🔒 Secure link powered by ALARMS AMERICA. ADT AUTHORIZED DEALER
      </p>
    </div>
  );
}
